interface SeoProps {
  title: string;
  description: string;
  keywords?: string;
}

export default function Seo({ title, description, keywords }: SeoProps) {
  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      {keywords ? <meta name="keywords" content={keywords} /> : null}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
    </>
  );
}